var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReset = function SvgReset(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.88889L6.75778 7.13111C8.16475 5.77095 10.0431 5.00736 12 5C13.3845 5 14.7378 5.41054 15.889 6.17971C17.0401 6.94888 17.9373 8.04213 18.4672 9.32121C18.997 10.6003 19.1356 12.0078 18.8655 13.3656C18.5954 14.7235 17.9287 15.9708 16.9497 16.9497C15.9708 17.9287 14.7235 18.5954 13.3656 18.8655C12.0078 19.1356 10.6003 18.997 9.32121 18.4672C8.04213 17.9373 6.94888 17.0401 6.17971 15.889C5.579 14.99 5.19703 13.9676 5.05853 12.9034M5 8.88889V5M5 8.88889H8.88889",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export { ForwardRef as ReactComponent };